import { useState } from "react"
import {ChevronDown} from 'lucide-react'

const faqs = [
  {
    question: "O que exatamente significa \"Saia do básico em 6 meses ou seu dinheiro de volta\"?",
    answer: "Significa que, se você seguir todos os critérios de uso da promoção e não apresentar evolução mínima comprovada nos testes ao final de 6 meses, poderá solicitar o reembolso do valor pago, conforme os termos."
  },
  {
    question: "Quais são os critérios obrigatórios para participar da promoção?",
    answer: "Para ter direito à garantia, você precisa:\n\n✔ Acessar a plataforma com mínimo de 15 min por sessão e 2 acessos por semana\n✔ Interagir com a Lucy IA pelo menos 3 vezes por semana\n✔ Participar de no mínimo 3 aulões ao vivo por mês\n✔ Fazer a avaliação inicial e a final de conhecimento\n\nEsses critérios serão verificados para conferir sua elegibilidade ao reembolso."
  },
  {
    question: "O que é considerado evolução mínima de aprendizado?",
    answer: "Só será considerado para reembolso o caso em que, após análise técnica, não for identificada evolução mínima comprovada pelos testes de início e fim do programa. A avaliação subjetiva (\"eu senti que não evoluí\") não conta por si só."
  },
  {
    question: "Como eu solicito o reembolso se eu não evoluir?",
    answer: "Você poderá solicitar o reembolso em até 7 dias após o término dos 6 meses. A empresa fará uma análise em até 30 dias usando os registros de uso da plataforma, Lucy IA e a participação nos aulões."
  },
  {
    question: "Posso perder o direito ao reembolso por não acessar?",
    answer: "Sim. A promoção exige que você cumpra os critérios de uso (acesso, interações e participações mencionadas acima). Se você não cumprir esses requisitos, não terá direito ao reembolso."
  },
  {
    question: "A garantia substitui o direito de arrependimento?",
    answer: "Não. O direito de arrependimento de 7 dias após a compra é um direito do consumidor e funciona separadamente. Já a garantia de evolução em 6 meses depende do seu cumprimento dos critérios da promoção."
  },
  {
    question: "E se eu cancelar antes dos 6 meses?",
    answer: "Você pode cancelar sua assinatura a qualquer momento, mas cancelar antes de completar os critérios da promoção pode invalidar o direito ao reembolso da garantia de evolução."
  },
  {
    question: "Há alguma forma de manipular a promoção?",
    answer: "Qualquer tentativa de manipular uso da plataforma, participação nos aulões, interações com a Lucy IA ou de usar a conta indevidamente pode resultar em suspensão e perda do direito ao benefício da promoção."
  }
]

function FAQItem({ question, answer, isOpen, onClick }: {
  question: string
  answer: string
  isOpen: boolean
  onClick: () => void
}) {
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-blue-300 hover:shadow-md">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-blue-50/50 transition-colors duration-200"
      >
        <span className="font-bold text-gray-800 text-base md:text-lg pr-4" style={{ fontFamily: "'Bitter', serif" }}>
          {question}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-blue-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
      >
        <div className="px-6 pb-5 pt-1 text-gray-600 text-sm md:text-base leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Open Sans', sans-serif" }}>
          {answer}
        </div>
      </div>
    </div>
  )
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-block bg-blue-100 text-blue-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Dúvidas Frequentes
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900"
            style={{ fontFamily: "'Bitter', serif" }}
          >
            Perguntas sobre a{" "}
            <span className="text-blue-600">garantia de evolução</span>
          </h2>
          <p className="text-gray-500 mt-3 text-base md:text-lg" style={{ fontFamily: "'Open Sans', sans-serif" }}>
            Transparência total para você decidir com segurança.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => toggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}